var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.modals, function(modal) {
        return [
          _c(
            "v-dialog",
            _vm._b(
              {
                key: modal.id,
                ref: "dialog_for_" + modal.id,
                refInFor: true,
                attrs: { value: modal.show },
                on: {
                  input: function($event) {
                    return _vm.dialogInput(modal, $event)
                  }
                }
              },
              "v-dialog",
              modal.dialog,
              false
            ),
            [
              _c(
                modal.component,
                _vm._g(
                  _vm._b(
                    {
                      key: "comp_" + modal.id,
                      tag: "component",
                      attrs: { modalId: modal.id },
                      on: {
                        "modal-close": function($event) {
                          return _vm.ui__closeModal(modal.id)
                        },
                        "modal-hide": function($event) {
                          return _vm.ui__hideModal(modal.id)
                        },
                        "modal-show": function($event) {
                          return _vm.ui__showModal(modal.id)
                        }
                      }
                    },
                    "component",
                    modal.bind,
                    false
                  ),
                  modal.on
                )
              )
            ],
            1
          )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }